import React from "react";
import { Link } from "react-router-dom";
export const NotAuthorized = () => {
    return (React.createElement("div", null,
        React.createElement("h1", null, "NOT AUTHORIZED: You have attempted to view a record that you are not authorized for."),
        React.createElement("h2", null, "Please contact the Portal Administrators or Complaints Team if you think you should be able to view this record."),
        React.createElement("p", null, "Development message: have you set a user using the drop down at the top-left of the screen?"),
        React.createElement("h2", null,
            React.createElement(Link, { to: "/complaints" }, "Click to go to the Complaints home page"))));
};
